import { observer } from 'mobx-react'
import { FormatNumber } from '../../../components';

/* eslint-disable max-len */
export default observer(function ChildrenCard({ item, onShow }) {

    return <div className='list-card-item row'>
        <div className='col-5 card-detail-image d-flex pt-4 align-items-center justify-content-center'>
            <img className='w-100 max-width-190' src={item?.image}></img>
        </div>
        <div className='card-detail-label col-7'>
            <div className='py-2'>
                {item?.variationRate < 0 ? <div className='d-flex text-danger'>
                    <div className='card-detail-label-item-icon width-70'>
                        {/* <i className="fa-solid fa-arrow-down"></i> */}
                        <img src='/images/icon_down_rate.svg'></img>
                    </div>
                    <div className='d-block card-detail-label-item-text'>
                        <div className='mg-b-1 w-100 text-danger' >騰落率</div>
                        <span className='font-semi-bold fs-label text-danger' > <FormatNumber allowNegative className='text-danger' statusDisplay='text' value={item?.variationRate} decimalScale={2} suffix=' %' /></span>
                        {/* <span className='font-semi-bold fs-label text-color-cs-4 '> {item?.variationRate ? parseFloat(item?.variationRate.toFixed(2)) : ''}%</span> */}
                    </div>
                </div> : item?.variationRate > 0 ?
                    <div className='d-flex text-color-cs-5'>
                        <div className='card-detail-label-item-icon width-70'>
                            <img src='/images/icon_rate_up.svg'></img>
                        </div>
                        <div className='d-block card-detail-label-item-text '>
                            <div className='mg-b-1 w-100 text-color-cs-14' >騰落率</div>
                            <span className='font-semi-bold fs-label text-color-cs-4' > <FormatNumber prefix='+' className='font-semi-bold fs-label text-color-cs-14' statusDisplay='text' value={item?.variationRate} decimalScale={2} suffix=' %' /></span>

                            {/* <span className='font-semi-bold fs-label text-color-cs-4 '>+ {item?.variationRate ? parseFloat(item?.variationRate.toFixed(2)) : ''}%</span> */}
                        </div>
                    </div> : <div className='d-flex '>
                        <div className='card-detail-label-item-icon width-70'>
                            <img src='/images/icon_equal_rate.svg'></img>
                        </div>
                        <div className='d-block card-detail-label-item-text '>
                            <div className='mg-b-1 w-100' >騰落率</div>
                            <span className='font-semi-bold fs-label '> {item?.variationRate}%</span>
                        </div>
                    </div>}
                <div className='d-flex align-items-center mb-1 card-item '>
                    <div className='width-70'>
                        <div className='card-detail-label-item-icon p-1 d-flex 
                            align-items-center justify-content-center rounded  width-35 height-35 card-item-icon'>
                            <img src='/images/icon_coin.svg'></img>
                        </div>
                    </div>
                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >トークン</span>
                        <span className='d-block font-semi-bold' >{item?.token?.name}</span>
                    </div>
                </div>
                <div className='d-flex align-items-center mb-1 card-item '>
                    <div className='width-70'>
                        <div className='card-detail-label-item-icon p-1 d-flex 
                            align-items-center justify-content-center rounded  width-35 height-35 card-item-icon'>
                            <img src='/images/icon_home.svg'></img>
                        </div>
                    </div>
                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >取引所</span>
                        <span className='d-block font-semi-bold' >{item?.exchange?.name}</span>
                    </div>
                </div>
                <div className='d-flex align-items-center mb-1 card-item '>
                    <div className='width-70'>
                        <div className='card-detail-label-item-icon p-1 d-flex 
                            align-items-center justify-content-center rounded  width-35 height-35 card-item-icon'>
                            <img src='/images/icon_calendar.svg'></img>
                        </div>
                    </div>
                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >発行日時</span>
                        <span className='d-block font-semi-bold' >{item?.publicAt}</span>
                    </div>
                </div>

                <div className='d-flex align-items-center mb-1 card-item '>
                    <div className='width-70'>
                        <div className='card-detail-label-item-icon p-1
                            d-flex align-items-center justify-content-center  rounded  width-35 height-35 card-item-icon '>
                            <img src='/images/icon_purchase_price.svg'></img>
                        </div>
                    </div>

                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >カード価格</span>
                        <span className='d-block font-semi-bold' >{<div> <FormatNumber statusDisplay='text' value={item?.cardPrice} suffix=' 円' /> </div>}</span>
                    </div>
                </div>
                <div className='d-flex align-items-center mb-1 card-item  '>
                    <div className='width-70'>

                        <div className='card-detail-label-item-icon p-1
                            d-flex align-items-center justify-content-center rounded  width-35 height-35 card-item-icon'>
                            <img src='/images/icon_rate_buy.svg'></img>
                        </div>
                    </div>
                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >基準レート</span>
                        <span className='d-block font-semi-bold' >{item?.baseRate} USDT</span>
                    </div>
                    {/* <div>
                            <span className='card-detail-label-item-text d-block' >{item.rateCurrent}</span>
                            <span className='card-detail-label-item-text d-block' >{item.rateCurrent}</span>
                        </div> */}
                </div>
                <div className='d-flex align-items-center mb-1 card-item  '>
                    <div className='width-70'>
                        <div className='card-detail-label-item-icon p-1
                            d-flex align-items-center justify-content-center  rounded  width-35 height-35 card-item-icon'>
                            <img src='/images/icon_curent_rate.svg'></img>
                        </div>
                    </div>

                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >現在レート</span>
                        <span className='d-block ' > <FormatNumber statusDisplay='text' value={item?.currentRate} decimalScale={6} suffix=' USDT' /></span>
                        {/* <span className='d-block font-semi-bold' >{parseFloat((+item?.currentRate).toFixed(6))}</span> */}
                    </div>
                </div>
                <div className='d-flex align-items-center mb-1 card-item  '>
                    <div className='width-70'>
                        <div className='card-detail-label-item-icon p-1
                            d-flex align-items-center justify-content-center rounded  width-35 height-35 card-item-icon'>
                            <img src='/images/icon_currency.svg'></img>
                        </div>
                    </div>

                    <div className=''>
                        <span className='d-block card-detail-label-item text-color-cs-13' >Airdrop</span>
                        <span className='d-block font-semi-bold' >{<div> <FormatNumber statusDisplay='text' value={item?.airdrop} suffix={` ${item?.token?.unit}`} />  </div>}</span>
                    </div>
                </div>
                
            </div>
        </div>
        <div className='d-flex lg:px-4 py-2'>
            {
                item?.isHolded ?
                    <div className='text-center font-weight-bold text-danger'>
              既に所有者がいる
                    </div>
                    :
                    <button onClick={() => onShow(item?.id)}
                        className='d-flex align-items-center justify-content-center height-35 rounded btn-bg-cs-1 col-12 
                                font-weight-bold flex-gap-8'>
                        <img src='/images/icon_add_circle.svg' />
                        <span className='fs-cs-16 font-semi-bold'>Holderに追加する</span>
                    </button>
            }
        </div>
    </div>
});